"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCTAFooterV2 = exports.MobileCTAFooterV2Variant = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MobileCTAFooterV2_module_css_1 = __importDefault(require("./MobileCTAFooterV2.module.css"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const web_sds_c_1 = require("@snapchat/web-sds-c");
const attribution_1 = require("../CTAFooter/attribution");
const CTAFooter_1 = require("../CTAFooter");
const react_1 = require("react");
const hooks_1 = require("../../utils/hooks");
const MobileExpandedCTABanner_1 = require("../CTAFooter/MobileCTAVariants/MobileExpandedCTABanner");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
exports.MobileCTAFooterV2Variant = {
    BLUE: "BLUE",
    PRIMARY_PAGE_COLOR: "PRIMARY_PAGE_COLOR",
};
/**
 * Mobile CTA Footer V2 - https://www.figma.com/file/LqylHro3PYNCNZhH79WLQS/Deep-Link-CTA-Optimization?type=design&node-id=960-25653&t=olM8LoE59LizGFOu-4
 */
function MobileCTAFooterV2(props) {
    const intl = (0, react_intl_1.useIntl)();
    const { prefixText = intl.formatMessage({
        id: "E3ZpW0",
        defaultMessage: "There's more to see in the app",
        description: "CTA message to urge users to open this page in the app instead",
    }), prefixImgUrl = "https://static.snapchat.com/favicon.ico", variant, noNavV2, webClientId, scrollDirection, webPageViewTraceId, pageType, attribution, } = props;
    const oneLink = (0, react_1.useMemo)(() => (0, CTAFooter_1.tryGenerateOneLinkOrDefault)({
        oneLinkParams: attribution.oneLinkParams,
        webClientId,
        webPageViewTraceId,
        fallbackUrl: "",
        pageType,
    }), [attribution.oneLinkParams, pageType, webClientId, webPageViewTraceId]);
    const scrollClassName = (0, clsx_1.default)({
        [MobileCTAFooterV2_module_css_1.default.containerVisibleWithNav]: scrollDirection !== hooks_1.Scroll.DOWN && !noNavV2,
        [MobileCTAFooterV2_module_css_1.default.containerVisibleWithoutNav]: scrollDirection !== hooks_1.Scroll.DOWN && noNavV2,
        [MobileCTAFooterV2_module_css_1.default.containerHiddenWithNav]: scrollDirection === hooks_1.Scroll.DOWN && !noNavV2,
        [MobileCTAFooterV2_module_css_1.default.containerHiddenWithoutNav]: scrollDirection === hooks_1.Scroll.DOWN && noNavV2,
    });
    const onOpenInSnapchatClick = () => {
        const actionUrl = (0, attribution_1.getMobileAttributionLink)({
            oneLink,
            openInAppLink: attribution.openInSnapchatLink,
            downloadLink: attribution.downloadLink,
        });
        if (actionUrl) {
            void (0, web_blizzard_reporting_1.reportWebAction)({
                pageType,
                actionName: web_blizzard_reporting_1.WebActionName.OpenInSnapchatCta,
                deepLinkUrl: actionUrl,
                actionSource: web_blizzard_reporting_1.WebActionSource.CTAFooter,
                webClientId,
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("a", { className: (0, clsx_1.default)(MobileCTAFooterV2_module_css_1.default.container, scrollClassName, {
                    [MobileCTAFooterV2_module_css_1.default.blueContainer]: variant === exports.MobileCTAFooterV2Variant.BLUE,
                    [MobileCTAFooterV2_module_css_1.default.primaryPageColorContainer]: variant === exports.MobileCTAFooterV2Variant.PRIMARY_PAGE_COLOR,
                }), "data-testid": "cta-footer-v2-link", href: (0, attribution_1.getMobileAttributionLink)({
                    oneLink,
                    openInAppLink: attribution.openInSnapchatLink,
                    downloadLink: attribution.downloadLink,
                }), onClick: onOpenInSnapchatClick, children: [(0, jsx_runtime_1.jsx)("img", { className: MobileCTAFooterV2_module_css_1.default.prefixImg, src: prefixImgUrl, alt: prefixText }), (0, jsx_runtime_1.jsx)("span", { className: MobileCTAFooterV2_module_css_1.default.prefixText, children: prefixText }), (0, jsx_runtime_1.jsx)("span", { className: MobileCTAFooterV2_module_css_1.default.buttonContainer, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: variant === exports.MobileCTAFooterV2Variant.BLUE ? web_sds_c_1.ButtonColor.WHITE : web_sds_c_1.ButtonColor.BLUE, children: oneLink || attribution.openInSnapchatLink ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { description: "Open App button text", defaultMessage: "Open app", id: "5UloV/" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { description: "Download Snapchat button text", defaultMessage: "Download Snapchat", id: "6oWDxF" })) }) })] }), (0, jsx_runtime_1.jsx)("div", { className: MobileCTAFooterV2_module_css_1.default.mobileCustomFooterWrapper, children: (0, jsx_runtime_1.jsx)(MobileExpandedCTABanner_1.MobileExpandedCTABanner, { downloadLink: attribution.downloadLink ?? "", link: oneLink, openInSnapchatLink: attribution.openInSnapchatLink, onClick: onOpenInSnapchatClick, showBackdrop: true }) })] }));
}
exports.MobileCTAFooterV2 = MobileCTAFooterV2;
//# sourceMappingURL=index.js.map